import NavLink2 from './NavLink2'
export default NavLink2